<template>
  <div class="consult-offer-result">
    <span class="title">{{ offerSchedule.name }}</span>
    <span class="subtitle"> {{ offerType }} | {{ startDate }} - {{ endDate }} </span>
    <div class="d-flex flex-row align-center">
      <mf-icon fill class="status-icon" small :color="getStatusColor" icon="stop_circle" />
      <span class="status-text">{{ getStatusText }}</span>
    </div>
    <general-offer-sale
      v-for="offerSale in offerSchedule.offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :has-segments="hasSegments"
      :is-activable="offerSchedule.activatable"
    />
    <percentage-offer-sale
      v-for="offerSale in offerSchedule.percentage_offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :is-activable="offerSchedule.activatable"
    />
    <take-pay-offer-sale
      v-for="offerSale in offerSchedule.takepay_offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :is-activable="offerSchedule.activatable"
    />
    <next-buy-cashback-offer-sale
      v-for="offerSale in offerSchedule.next_buy_cashback_offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :is-activable="offerSchedule.activatable"
    />
    <cashback-absolute-offer-sale
      v-for="offerSale in offerSchedule.cashback_absolute_offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :is-activable="offerSchedule.activatable"
    />
    <cashback-percentage-offer-sale
      v-for="offerSale in offerSchedule.cashback_percentage_offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :is-activable="offerSchedule.activatable"
    />
    <points-offer-sale
      v-for="offerSale in offerSchedule.points_offer_sales"
      :key="offerSale.sku || offerSale._id"
      style="flex: 1"
      :offerSale="offerSale"
      :is-activable="offerSchedule.activatable"
    />
    <combo-offer-sale-base
      v-for="combo in offerSchedule.combo_offer_sales"
      :key="combo.combo_id"
      style="flex: 1"
      :combo="combo"
      :is-activable="offerSchedule.activatable"
    />
    <cross-sell-offer-sale-base
      v-for="(combo, index) in offerSchedule.cross_sell_offer_sales"
      :key="index"
      style="flex: 1"
      :combo="combo"
      :is-activable="offerSchedule.activatable"
    />
    <dynamic-rule-offer-sale-base v-for="(combo, index) in offerSchedule.dynamic_rule_offer_sales" :key="index" style="flex: 1" :combo="combo" />
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { getProductFormatTypeLabel } from '@/modules/mobile/ofertas/helpers/productType.js'
import { getStatusLabel } from '@/config/helpers.js'
import GeneralOfferSale from './offer-sales/GeneralOfferSale.vue'
import PercentageOfferSale from './offer-sales/PercentageOfferSale.vue'
import TakePayOfferSale from './offer-sales/TakePayOfferSale.vue'
import NextBuyCashbackOfferSale from './offer-sales/NextBuyCashbackOfferSale.vue'
import CashbackAbsoluteOfferSale from './offer-sales/CashbackAbsoluteOfferSale.vue'
import CashbackPercentageOfferSale from './offer-sales/CashbackPercentageOfferSale.vue'
import PointsOfferSale from './offer-sales/PointsOfferSale.vue'
import ComboOfferSaleBase from './offer-sales/ComboOfferSaleBase.vue'
import CrossSellOfferSaleBase from './offer-sales/CrossSellOfferSaleBase.vue'
import DynamicRuleOfferSaleBase from './offer-sales/DynamicRuleOfferSaleBase.vue'

export default {
  name: 'ConsultOfferResult',
  components: {
    GeneralOfferSale,
    PercentageOfferSale,
    TakePayOfferSale,
    NextBuyCashbackOfferSale,
    CashbackAbsoluteOfferSale,
    CashbackPercentageOfferSale,
    PointsOfferSale,
    ComboOfferSaleBase,
    CrossSellOfferSaleBase,
    DynamicRuleOfferSaleBase,
  },
  props: {
    offerSchedule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    offerType() {
      if (this.offerSchedule.types && this.offerSchedule.types.length > 1) {
        return 'Múltiplos'
      } else {
        return getProductFormatTypeLabel(this.offerSchedule.types[0])
      }
    },
    startDate() {
      return DateTime.fromISO(this.offerSchedule.start_date).toFormat('dd/MM/yyyy')
    },
    endDate() {
      const endDate = DateTime.fromISO(this.offerSchedule.end_date).toFormat('dd/MM/yyyy')
      return endDate || this.startDate
    },
    getStatusColor() {
      return getStatusLabel(this.offerSchedule?.status).color
    },
    getStatusText() {
      return getStatusLabel(this.offerSchedule?.status).text
    },
    hasSegments() {
      return this.offerSchedule.segments && this.offerSchedule.segments.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.consult-offer-result {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.01em;
    text-align: left;
    color: $marca-0;
  }

  .subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: $cinza-0;
  }
}
</style>
